import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { BYPASS_GLOBAL_LOADING, LoadingService } from '../services/loading.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private loadingService?: LoadingService;

  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Obtém o serviço de loading via injector para evitar dependência circular
    if (!this.loadingService) {
      this.loadingService = this.injector.get(LoadingService);
    }

    // Verifica se é uma requisição para a API
    const isApiRequest = request.url.includes(environment.apiUrl) || request.url.startsWith('/api/');
    
    // Ignora requisições de autenticação para não mostrar loading durante login
    const isAuthEndpoint = request.url.includes('/auth/login') || 
                          request.url.includes('/auth/validate-token') || 
                          request.url.includes('/auth/callback');
    
    // Ignora requisições de foto para não mostrar loading
    const isPhotoEndpoint = request.url.includes('/users/me/photo');
    const isQuickAccessEndpoint = request.url.includes('/user/quick-access');

    // Flag opt-in por requisição: o chamador assume o próprio indicador de progresso. Existe para
    // requisição que se repete em timer (polling) — o overlay pisca a cada ida e volta e bloqueia
    // a tela em que o utilizador está a trabalhar.
    const bypassGlobalLoading = request.context.get(BYPASS_GLOBAL_LOADING);

    // Mostra loading apenas para requisições da API que não sejam de autenticação, foto ou acessos rápidos
    const shouldShowLoading =
      isApiRequest && !isAuthEndpoint && !isPhotoEndpoint && !isQuickAccessEndpoint && !bypassGlobalLoading;

    if (shouldShowLoading && this.loadingService) {
      this.loadingService.show();
    }

    return next.handle(request).pipe(
      finalize(() => {
        // Esconde o loading quando a requisição terminar (sucesso ou erro)
        if (shouldShowLoading && this.loadingService) {
          this.loadingService.hide();
        }
      })
    );
  }
}
